import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import './story.css';

function Ourstory() {
  return (
    <>
      <Navbar />

      <div className="os-container">
        {/* Text Section */}
        <div className="os-text">
          <h2 className="os-title">Our Story</h2>
          <p className="os-paragraph">
            Ever wondered why nutrition labels sound impressive but often leave you more confused
            than informed? Why products promise big outcomes, yet understanding what actually
            supports your body feels harder than it should?
          </p>
          <p className="os-paragraph">
            I asked those same questions on the gym floor and in the lab. As a sports scientist
            working with real people — athletes, professionals, everyday movers — I kept seeing the
            same thing: effort was everywhere, but clarity was missing. People were training hard,
            trying to recover better, trying to improve their health — yet the support they relied
            on often felt disconnected from how the human body actually works.
          </p>
          <p className="os-paragraph">
            That’s where <span className="os-highlight">Evercore</span> started.
          </p>
          <p className="os-paragraph">
            I didn’t set out to build a brand. I set out to build a better way of doing things. One
            that respects physiology, values science, and treats people with honesty instead of
            hype.
          </p>
          <p className="os-paragraph">
            At <span className="os-highlight">Evercore</span>, we believe good nutrition starts with
            clarity — not shortcuts. We don’t promise instant results or use exaggerated language.
            Nutrition works through consistency, not miracles, and we design with that reality in
            mind. Every ingredient we use has a reason to exist — whether it supports nutrition,
            improves absorption, or helps keep a product stable and safe. Nothing goes in randomly.
            And if something is included, we believe it should make sense.
          </p>
          <p className="os-paragraph">
            We’re also honest about reality. Not every format can be “perfectly natural,” and we
            don’t pretend otherwise. When something is necessary for safety, quality, or usability,
            we choose carefully and use only what’s needed — guided by science and practical
            nutrition, not trends.
          </p>
          <p className="os-paragraph">
            <span className="os-highlight">Evercore</span> is still early in its journey. But the
            mission is clear: to build performance-focused nutrition that people can trust, grow
            with, and rely on — without confusion, without noise, and without unnecessary
            complexity.
          </p>
          <p className="os-paragraph">That’s the standard we hold ourselves to.</p>
          <p className="os-paragraph">
            That’s <span className="os-highlight">Evercore</span>.
          </p>
        </div>

        {/* Image Section */}
        <div className="os-image">
          <div className="os-card">
            <img
              src="assets/images/Rishi.png"
              alt="Rishi"
              className="os-card-img"
            />
            <div className="os-card-info">
              <p className="os-card-name">Rishi</p>
              <p className="os-card-role">Founder and CEO</p>
              <p className="os-card-qualification">Masters in Sports Science</p>
            </div>
          </div>
        </div>
      </div>
       
      <Footer />
    </>
  );
}

export default Ourstory;
